import clsx from 'clsx';
import { format } from 'date-fns';
import { da } from 'date-fns/locale';
import { usePDPData, usePDPState } from '~/features/product-details/context';
import { TranslationKey } from '~/lib';
import { Typography, TypographyProps } from '~/shared/components';
import { useTranslation } from '~/shared/utils/translation';
import styles from './ProductCampaignLifeCycle.module.scss';

const DATE_FORMAT = 'dd.MM.yyyy';

const formatCampaignDate = (value: unknown) =>
    typeof value === 'string' && value ? format(new Date(value), DATE_FORMAT, { locale: da }) : '';

export const ProductCampaignLifeCycle: React.FC<TypographyProps> = ({ className, ...rest }) => {
    const { translate } = useTranslation();
    const { product } = usePDPData();
    const { isPromotionDiscountHeldBack } = usePDPState();

    const campaign = product.c_campaignLifeCycle;

    // Dates the discounted price, which is not shown until the countdown ends.
    if (isPromotionDiscountHeldBack) return null;

    if (!campaign?.type || campaign.type === 'none') return null;

    return (
        <Typography
            className={clsx(styles.campaignLifeCycle, className)}
            variant="paragraph-S"
            as="p"
            {...rest}
        >
            {translate(`campaign.${campaign.type}` as TranslationKey, {
                ...campaign,
                startDate: formatCampaignDate(campaign.startDate),
                endDate: formatCampaignDate(campaign.endDate),
            })}
        </Typography>
    );
};
